import styled from '@emotion/styled';
import { Box } from '@hover/blueprint';

export const StyledBoxTrusted = styled.div<{
  left: number;
  width: number;
  time: number;
  delayTime: number;
  top: number;
}>`
  position: absolute;
  left: -${props => props.left}px;
  width: ${props => props.width}px;
  top: ${props => props.top}px;

  @keyframes bannerMovePerson {
    0% {
      left: ${props => `-${props.left}px`};
    }
    100% {
      left: 100%;
    }
  }
  animation: bannerMovePerson ${props => props.time}s linear
    ${props => props.delayTime}s infinite;
`;

export const StyledFade = styled(Box)`
  &:before {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0,
      rgba(255, 255, 255, 0) 100%
    );
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 150px;
    height: 100%;
    border-collapse: separate;
    z-index: 100;
  }
  &:after {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 1) 80%
    );
    overflow: hidden;
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    width: 150px;
    height: 100%;
    border-collapse: separate;
  }
`;
